import { type Opportunity } from "@repo/api";
import { t } from "@repo/translation";
import { ModalSheet, SectionContainer, useSettings } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";
import { useState } from "react";

import { ProjectProgressSelector } from "./ProjectProgressSelector";

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  updateStatus: (
    newStatus: Opportunity["status"],
    reason: string | undefined,
    description: string | undefined
  ) => void;
  currentStatus: Opportunity["status"];
}

export const ProjectProgressModal = ({
  isOpen,
  closeModal,
  updateStatus,
  currentStatus,
}: Props) => {
  const { general } = useSettings();
  const [selectedStatus, setSelectedStatus] =
    useState<Opportunity["status"]>(currentStatus);
  const [selectedReason, setSelectedReason] = useState<string | undefined>(
    undefined
  );
  const [description, setDescription] = useState<string | undefined>(undefined);
  const reasons = general?.reasons?.project_status_change?.[selectedStatus];

  const resetState = () => {
    setSelectedReason(undefined);
    setDescription(undefined);
  };

  return (
    <ModalSheet
      title={t("action.change_status")}
      visible={isOpen}
      onClose={() => {
        resetState();
        closeModal();
      }}
      primaryButtonProps={{
        text: t("action.save"),
        onClick: () => {
          updateStatus(selectedStatus, selectedReason, description);
          trackAnalytics("save_change_status");
        },
        disabled:
          currentStatus === selectedStatus || (reasons && !selectedReason),
      }}
    >
      <SectionContainer>
        <ProjectProgressSelector
          setDescription={setDescription}
          setSelectedReason={setSelectedReason}
          setSelectedStatus={setSelectedStatus}
          selectedStatus={selectedStatus}
          currentStatus={currentStatus}
          reasons={reasons}
        />
      </SectionContainer>
    </ModalSheet>
  );
};
